import React, { Component } from 'react';

class OptionalLabel extends Component {
  render() {
    return <div>{this.props.children}</div>;
  }
}

export default OptionalLabel;
